import Glide from '@glidejs/glide';
import { Swipe, Anchors } from '@glidejs/glide/dist/glide.modular.esm';
import requestTimeout from './common/requestTimeout';

const SELECTORS = Selectors({
    // imageSlide: '[data-image-slide]',
    // imageSlider: '.image__slider',

    contentSlide: '[data-testimonial-slide]',
    contentSlider: '.testimonials__slider',
    bullets: '[data-glide-dir]',
});

const slides = document.querySelectorAll(SELECTORS.contentSlide);
// const imageSlider = document.querySelector(SELECTORS.imageSlider);
const testimonialSlider = document.querySelector(SELECTORS.contentSlider);

const fn = {
    init: () => {
        fn.setupTestimonialSlider();
    },

    setupTestimonialSlider: () => {
        const options = {
            type: 'carousel',
            perView: 1,
            focusAt: 0,
            startAt: 2,
            autoplay: 5000,
            // autoplay: false
        };
        // const imageOptions = {
        //     type: 'carousel',
        //     perView: 6,
        //     focusAt: 'center',
        //     startAt: 2,
        //     gap: 2,
        //     breakpoints: {
        //         768: {
        //             perView: 5,
        //             gap: 0,
        //         },
        //         480: {
        //             perView: 1,
        //             gap: 0,
        //         },
        //     },
        // };

        const slider1 = new Glide(testimonialSlider, options);
        // const slider2 = new Glide(imageSlider, imageOptions);

        // slider1.on('run', e => {
        //     slider2.go(e.direction);
        // });

        // slider2.on('run', e => {
        //     slider1.go(e.direction);
        // });

        // slider2.mount({ Swipe, Anchors });
        slider1.mount({ Swipe, Anchors });
    },
};

export default {
    can: () => slides.length,
    run: fn.init,
};
